module.exports = __webpack_public_path__ + "static/6-124e09ba360c00fc0c19ddae111072cd.jpg";